module.exports = __webpack_public_path__ + "static/timeline_totale-a5bd95f132da850c3bfa98135a85da57.jpg";